var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAuditTrail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M17.5 7.25V17c0 3-1.79 4-4 4h-8c-2.21 0-4-1-4-4V7.25c0-3.25 1.79-4 4-4a2.24 2.24 0 0 0 .66 1.59 2.24 2.24 0 0 0 1.59.66h3.5a2.253 2.253 0 0 0 2.25-2.25c2.21 0 4 .75 4 4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#292D32",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M13.5 3.25a2.253 2.253 0 0 1-2.25 2.25h-3.5a2.25 2.25 0 1 1 0-4.5h3.5a2.253 2.253 0 0 1 2.25 2.25M5.5 12h4M5.5 16h8"
})));
export { SvgAuditTrail as ReactComponent };
export default __webpack_public_path__ + "eb06333cf064257731131e8f93607261.svg";